import { render, staticRenderFns } from "./VHeader.vue?vue&type=template&id=731221c7&scoped=true"
import script from "./VHeader.vue?vue&type=script&lang=ts"
export * from "./VHeader.vue?vue&type=script&lang=ts"
import style0 from "./VHeader.vue?vue&type=style&index=0&id=731221c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731221c7",
  null
  
)

export default component.exports